<template>
  <div class="hexline">
    <!-- eslint-disable vue/no-v-html -->
    <!-- eslint-disable vue/singleline-html-element-content-newline -->
    <span class="text-darkred">{{ hex_position }}</span
    ><span>|</span
    ><template v-for="(byte, index) in hex_bytes">
      <!-- <span v-if="index !== 0">{{ ' ' }}</span> -->
      <span v-if="index % 2 === 0 && index !== 0">{{ ' ' }}</span>
      <span :class="hex_byte_class(index)" v-html="byte" /> </template
    ><span>|</span>
    <span class="text-darkgrey" v-html="ascii_bytes" />
    <!-- eslint-enable vue/singleline-html-element-content-newline -->
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<style scoped>
.hexline {
  font-family: roboto mono, dejavu sans mono, courier, courier new, serif;
  font-size: 21px;
  line-height: 21px;
  white-space: nowrap;
}
</style>

<script>
import _ from 'lodash'

import Vue from 'vue'

import HexViewerLine from '@/components/hex_viewer_line.vue'

// *****************************************************************************

const editedcp1252_chars =
  '................................ !"#$%&\'()*+,-./' +
  '0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_' +
  '`abcdefghijklmnopqrstuvwxyz{|}~\x7f.............' +
  '...................' +
  '\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac.\xae\xaf' +
  '\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf' +
  '\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf' +
  '\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf' +
  '\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef' +
  '\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff'

function position_to_string(position) {
  let res = _.padStart(position.toString(16), 16, '0').toUpperCase()
  return res
}

// *****************************************************************************

export default {
  name: 'HexViewerLine',
  components: {},
  props: ['bytes', 'start', 'stop', 'unknown'],
  data() {
    return {}
  },
  computed: {
    hex_bytes() {
      let res
      if (this.unknown) {
        res = Array(this.stop - this.start).fill('??')
      } else {
        res = []
        let bytes = this.bytes || new Uint8Array(new ArrayBuffer(0))
        let nb = this.stop - this.start
        for (let i of _.range(nb)) {
          let byte = bytes[i]
          let t = '&nbsp;&nbsp;'
          if (!_.isUndefined(byte)) {
            t = _.padStart(bytes[i].toString(16), 2, '0').toUpperCase()
          }
          res.push(t)
        }
      }
      return res
    },
    hex_position() {
      return position_to_string(this.start)
    },
    ascii_bytes() {
      let res
      if (this.unknown) {
        res = '?'.repeat(this.stop - this.start)
      } else {
        res = ''
        let bytes = this.bytes || new Uint8Array(new ArrayBuffer(0))
        let nb = this.stop - this.start
        for (let i of _.range(nb)) {
          let byte = bytes[i]
          let t = '&nbsp;'
          if (!_.isUndefined(byte)) {
            t = editedcp1252_chars[byte]
          }
          res += t
        }
      }
      return res
    },
  },
  methods: {
    hex_byte_class(index) {
      let res = ['text-darkblue']
      if (index % 2 === 0) {
        res = ['text-darkgrey']
      }
      return res
    },
  },
}
</script>
